module.exports = __webpack_public_path__ + "static/img/6.d59b01b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/6.png
// module id = M+up
// module chunks = 0